import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { object, string } from 'yup';

import { formMessages } from '@/messages/forms';

export type IdentifyWatchSchema = InferType<
  ReturnType<typeof identifyWatchSchema>
>;

export const identifyWatchSchema = (
  formatMessage: IntlShape['formatMessage'],
) => {
  const requiredMsg = formatMessage(formMessages.requiredField);

  const schema = object({
    sn: string().required(requiredMsg).default(''),
  });
  return schema;
};
